/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdWebFeaturesGamesChooseGameTurnstileOptions } from './FxIdWebFeaturesGamesChooseGameTurnstileOptions';
import {
    instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions,
    FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSON,
    FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped,
    FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSON,
} from './FxIdWebFeaturesGamesChooseGameTurnstileOptions';

/**
 * @type FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile
 * Настройки для Cloudflare Turnstile
 * @export
 */
export type FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile = FxIdWebFeaturesGamesChooseGameTurnstileOptions;

export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSON(json: any): FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile {
    return FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSONTyped(json, false);
}

export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions(json)) {
        return FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSON(json: any): any {
    return FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSONTyped(json, false);
}

export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSONTyped(value?: FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions(value)) {
        return FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSON(value as FxIdWebFeaturesGamesChooseGameTurnstileOptions);
    }

    return {};
}

